<template>
  <div id="app">
      <!-- <div style="position:fixed;width:100px;height:30px;text-align:center;left:97%;top:30%;z-index:555">
        <li style="width:43px;height:40px;background-color:#64aaf1;color: #fff;font-size:14px;    line-height: 40px;">客服</li>
         <li style="width:43px;height:40px;background-color:#CCCCCC;color: #fff;font-size:18px;    line-height: 40px;"><i class="el-icon-service"></i></li>
         <li style="width:43px;height:40px;background-color:#CCCCCC;color: #fff;font-size:18px;    line-height: 40px;"><i class="el-icon-service"></i></li>
      </div> -->
    <router-view/>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  name: 'App',
  mounted(){
      //   var userData={
      //   balance :'5',
      //   employee_serial:'20000001',
      //   permissions_id:'1',
      //   studentDepartment_serial:'10008',
      //   company_serial:'10004',
      //   father_serial :'0',
      //   user_serial:'200000001',
      //   teacher_name:'王枫',
      //   score:'0'
      // }

      // sessionStorage.setItem('userData',qs.stringify(userData));
      
  }

}
</script>

<style>

  ul{
    margin: 0;padding: 0;
  }

  li {list-style-type:none;}
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    color: #2c3e50;
    width: 100%;
    height: 100%;
    margin:0;

  }
  /* .dialogCancelButton{
    margin-right: 80px !important;
  }

  #app>div{
    height: 100%;
  }
  .elTableBorder{
    border: 1px solid #c1c3c9 !important;

  } */
  /*#app>div>div:nth-child(2){*/
   /*height:100%;*/
  /*}*/
  /*以下为覆盖vue原来样式*/
  /* .el-form-item__label {
    text-align: left !important;
    vertical-align: middle !important;
    float: left !important;
    font-size: 12px !important;
    color: #303133 !important;
    line-height: 40px !important;
    padding: 0 12px 0 0 !important;
    -webkit-box-sizing: border-box !important;
    box-sizing: border-box !important;
  }
  .el-input__inner{
    border: 1px solid #c1c3c9 !important;
  }
  .el-form-item.is-success .el-input__inner{
border-color: #67c23a !important;
}
.el-form-item.is-error .el-input__inner{
border-color: #f56c6c !important;
}
  .el-header{
    padding: 0 !important;
  }
  .el-submenu .el-menu-item{
    min-width: 150px !important;
    padding-right: 0 !important;

  }
  .el-form-item{
    margin: 0 !important;
  }
  .el-tabs__header{
    margin:0 !important;
  }
  .el-dialog__title{
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  .el-dialog--center .el-dialog__body{
    padding: 0 20px 30px 20px !important;
  }
  .el-dialog__body{
    padding: 0 20px 30px 20px !important;
  }
 .el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color:#ff8534 !important
} */
.el-table--enable-row-hover .el-table__body tr:hover>td{
    background-color: #edf7e4 !important;
  }
  /*分页按钮颜色*/
    .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #84c34e !important;
  }
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
     border-color: red !important;
    border-radius: 25px !important;
    background-color: #ffffff !important;

  }
  /*菜单样式*/
  .el-menu{
    border-right:none !important;
  }
  .el-submenu .el-menu-item{
    min-width: 10% !important;
  }
  /*使用下方样式时只需调用前面的选择器*/
 /*椭圆输入框 and 椭圆下拉选框*/
 .inputRadius .el-input__inner{
  border-radius: 25px !important;
  height: 30px !important;
}
.el-select .el-input.is-focus .el-input__inner{
  border-color: #84c34e !important;
}
.el-select .el-input__inner:focus{
  border-color: #84c34e !important;
}
.el-input.is-active .el-input__inner, .el-input__inner:focus{
  border-color: #84c34e !important;
}
  .el-radio-button__inner:hover {
    color:#606266 !important;
  }

/*可下拉输入框*/
.inputText .el-textarea__inner{
  border-radius:10px !important;
}


/*计数器样式*/
.inputRadius .el-input-number.is-controls-right .el-input-number__decrease{
  height:10px !important;
  border: none !important;

}

/*tab页文字样式*/
.tabStyle .el-tabs__item.is-active{
  color: #84c34e !important;
}
/*tab页线条样式*/
 .tabStyle .el-tabs__active-bar{
   background-color: #84c34e !important;
   border-bottom: 1px solid #84c34e !important;
}
/*tab页移入文字样式*/
.tabStyle .el-tabs__item:hover{
   color: #84c34e !important;
}
/*下拉框圆角样式*/
.dialogStyle .el-dialog{
  border-radius: 10px !important;
}

/*菜单样式*/
a {
    text-decoration: none !important;
}
.router-link-active {
    text-decoration: none !important;
}

/* 时间选择器+图标位置*/
 .el-input__icon{
  line-height: 0px !important;
}

/*下拉按钮*/
.el-dropdown-selfdefine:focus, .el-dropdown-selfdefine:hover {
    color: #84c34e !important;
    border-color: #84c34e !important;
    background-color: #fff !important;
}

.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #84c34e !important;
    color: #fff !important;
}
.inputRadius .el-range-editor--mini .el-range-separator {
  margin:0 15px 0 0 !important;
}
 .nei .impowerBox .qrcode{
    width:100px !important;
  }
  /* 登录页输入框图标 */
  .loginBackground.el-input-group__append, .el-input-group__prepend{
    background-color: #28b779!important;
  }
  /* .headMenu.loginBackground2.el-input-group__append, .el-input-group__prepend{
    background-color: #ffb848!important;
  } */
    .headMenu.el-tabs--border-card>.el-tabs__header{
        background-color: #535d63!important;
        height:45px!important;
        
    }
   .headMenu .el-tabs__item{
       height:45px!important;
       font-size:16px!important;
       color:#fff!important;
       margin:0 0 0 20px!important;
    }
 


</style>




// WEBPACK FOOTER //
// src/App.vue